export function log(
  method: 'log' | 'debug' | 'error' | 'warn' = 'log',
  ...args: unknown[]
) {
  // eslint-disable-next-line no-console
  console[method](`[DevMetrics]`, ...args);
}
